import * as navigation from 'Navigation';

export default class ConnectionRunsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Runs',
      closeable: false,
      preferenceKey: 'connection-runs',
    };
  }
}
